module.exports = __webpack_public_path__ + "img/top-2-3.2716c51c.png";